import { useParams } from 'react-router-dom'
import { PlaceholderPage } from './PlaceholderPage'

export default function ProjectDetail() {
  const { id } = useParams()
  return <PlaceholderPage title={`Project: ${id}`} route="/projects/:id" />
}
